const whatsapp = {
  en: {
    table_view: 'Showing {pageTotal} of {total}',
    required_field: 'This field is required',
    dir: {
      whatsapp: 'WhatsApp / ',
      new: '/ New'
    },
    contacts: {
      create_contact: 'Create Contact',
      update_contact: 'Update Contact',
      add_contact: 'Add Contact',
      delete_contact_alert: 'Are you sure you want to delete this contact? Deleting this contact will prevent you from recovering the number later!',
    },
    contact: {
      contacts: 'Contacts',
      contact: 'Contact',
      first_name: 'First Name',
      last_name: 'Last Name',
      country_code: 'Country Code',
      phone_number: 'Phone Number',
      opted_in: 'Opted In',
      contact_lists: 'Contact Lists',
      existing_contact_lists: 'Existing Contact Lists',
      list_name: 'List Name',
      number_of_lists: 'No. of Lists',
      contacts_lists: 'Contact Lists',
      add_contact: 'Add Contact',
      no: 'No',
      yes: 'Yes',
      add_contact_list_to_contact: 'Add contact list to contact',
      empty_contact_list_search: 'There are no contact lists to show. Consider changing your search criteria.',
      search_to_find_contact_lists: 'Search to find contact lists',
      remove_contact_from_contact_lists: 'Remove contact from selected contact lists',
    },
    contact_lists: {
      create_contact_list: 'Create Contact List',
    },
    contact_list: {
      add_contact_list: 'Add Contact List',
      name: 'Name',
      contact_number: 'Contact Number',
      client: 'Client',
      project: 'Project',
      number_of_contacts: 'No. of Contacts',
      update_contact_list: 'Update Contact List',
      list_contacts: 'List Contacts',
      create_and_add_contact: 'New Contact',
      existing_contacts: 'Existing Contacts',
      add_to_contact_list: 'Add to Contact List',
      confirm_contact_remove: 'Are you sure you want to remove this contact?\nThe action will remove {name} from this contact list.',
      confirm_contact_list_remove: 'Are you sure you want to delete this contact list?',
      add_contact_to_list_tootlip: 'Add contact to contact list',
      empty_contact_search: 'There are no contacts to show. consider changing your search criteria.',
      search_to_find_contacts: 'Search to find contacts',
      remove_contacts_from_contact_list: 'Remove selected contacts from contact list',
    },
    placeholders: {
      enter_list_name: "Enter List Name",
      select_country_code: "Select Country Code",
      select_client: "Select a Client",
      select_project: "Select a Project",
    },
    buttons: {
      remove: 'Remove',
      delete: 'Delete',
      remove_batch: 'Remove ({amount})',
      edit: 'Edit',
      actions: 'Actions',
      add: 'Add ({amount})',
      resend_opt_in: 'Resend Opt In',
      sending_opt_in: 'Sending Opt In...',
      saving: 'Saving...',
      adding: 'Adding...',
      removing: 'Removing...',
    },
  }
}

module.exports.whatsapp = whatsapp;